(function () {
  'use strict';

  var INTERVAL_MS = 2000;

  function initRotator(rotatorEl) {
    if (rotatorEl.getAttribute('data-initialized') === 'true') return;

    var slides = rotatorEl.querySelectorAll('.agency-hero__slide');
    if (slides.length < 2) return;

    if (rotatorEl._rotatorIntervalId) {
      clearInterval(rotatorEl._rotatorIntervalId);
      rotatorEl._rotatorIntervalId = null;
    }
    rotatorEl.setAttribute('data-initialized', 'true');

    var dots = rotatorEl.querySelectorAll('.agency-hero__dot');
    var currentIndex = 0;

    function showSlide(index) {
      currentIndex = index;
      if (currentIndex >= slides.length) currentIndex = 0;
      if (currentIndex < 0) currentIndex = slides.length - 1;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        stopInterval();
        showSlide(idx);
        startInterval();
      });
    });

    function next() {
      showSlide(currentIndex + 1);
    }

    function startInterval() {
      if (rotatorEl._rotatorIntervalId) return;
      rotatorEl._rotatorIntervalId = setInterval(next, INTERVAL_MS);
    }

    function stopInterval() {
      if (rotatorEl._rotatorIntervalId) {
        clearInterval(rotatorEl._rotatorIntervalId);
        rotatorEl._rotatorIntervalId = null;
      }
    }

    rotatorEl.addEventListener('mouseenter', stopInterval);
    rotatorEl.addEventListener('mouseleave', startInterval);

    startInterval();
  }

  function initAll() {
    var rotators = document.querySelectorAll('[data-hero-rotator]');
    rotators.forEach(function (el) {
      el.removeAttribute('data-initialized');
      initRotator(el);
    });
  }

  function initSection(sectionEl) {
    var rotator = sectionEl ? sectionEl.querySelector('[data-hero-rotator]') : null;
    if (rotator) {
      rotator.removeAttribute('data-initialized');
      initRotator(rotator);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.detail && e.detail.sectionId;
      var sectionEl = section ? document.getElementById('agency-home-hero-' + section) : null;
      if (sectionEl) {
        initSection(sectionEl);
      } else {
        initAll();
      }
    });
  }
})();
